<template>
  <div
    id="schedule"
    class="bg-[#f7f9f9]"
  >
    <div class="co-container-xs px-4 py-20">
      <!-- 無料相談を予約する -->
      <img
        class="mx-auto mb-8 w-full max-w-[23.6rem]"
        src="~/assets/images/Te/TeCounseling/Apply/schedule-title.svg"
        alt="無料相談を予約する"
        loading="lazy"
      >
      <div class="flex items-center justify-center gap-1 text-co-primary-400">
        <FontAwesomeIcon
          :icon="faClockNine"
          class="fa-fw co-display-10 inline size-4"
        />
        <div class="co-display-12 font-bold">
          当日1時間後<span class="co-display-14 mr-1">から</span>8:00〜24:00<span class="co-display-14">まで</span>
        </div>
      </div>

      <!-- ステップ１ -->
      <div
        v-show="step === 1"
        class="mt-[3.25rem] text-center"
      >
        <img
          class="mx-auto mb-5"
          src="~/assets/images/Te/TeCounseling/Apply/step-one.svg"
          alt="マッチング"
          width="218"
          height="46"
          loading="lazy"
        >
        <div class="co-display-11 mb-8 font-bold">
          あなたの回答に沿ってマッチングを行います
        </div>

        <!-- 年代 -->
        <div class="co-display-12 mb-4 font-bold">
          年代
        </div>
        <div class="flex flex-col md:flex-row">
          <div class="mb-3 flex-auto">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': age === 10 }"
              @click="changeValue('age', 10)"
            >
              10代
            </button>
          </div>
          <div class="mb-3 flex-auto">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': age === 20 }"
              @click="changeValue('age', 20)"
            >
              20代
            </button>
          </div>
        </div>
        <div class="flex flex-col md:flex-row">
          <div class="mb-3 flex-auto">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': age === 30 }"
              @click="changeValue('age', 30)"
            >
              30代
            </button>
          </div>
          <div class="mb-3 flex-auto">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': age === 40 }"
              @click="changeValue('age', 40)"
            >
              40代
            </button>
          </div>
        </div>
        <div class="mb-8 flex flex-col md:flex-row">
          <div class="mb-3 flex-auto">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': age === 50 }"
              @click="changeValue('age', 50)"
            >
              50代以上
            </button>
          </div>
        </div>

        <!-- 性別 -->
        <div class="co-display-12 mb-4 font-bold">
          性別
        </div>
        <div class="flex flex-col md:flex-row">
          <div class="mb-3 flex-auto">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': gender === 1 }"
              @click="changeValue('gender', 1)"
            >
              男性
            </button>
          </div>
          <div class="mb-3 flex-auto">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': gender === 2 }"
              @click="changeValue('gender', 2)"
            >
              女性
            </button>
          </div>
        </div>
        <div class="flex flex-col md:flex-row">
          <div class="mb-3 flex-auto">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': gender === 3 }"
              @click="changeValue('gender', 3)"
            >
              未回答
            </button>
          </div>
        </div>

        <!-- 学習の目的 -->
        <div class="co-display-12 mb-4 font-bold">
          学習の目的
        </div>
        <div class="flex flex-col md:flex-row">
          <div class="mb-3 flex-auto">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': purpose === 'sidejob_freelance' }"
              @click="changeValue('purpose', 'sidejob_freelance')"
            >
              副業・フリーランス・在宅ワーク
            </button>
          </div>
          <div class="mb-3 flex-auto">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': purpose === 'jobchange' }"
              @click="changeValue('purpose', 'jobchange')"
            >
              就職・転職
            </button>
          </div>
        </div>
        <div class="mb-8 flex flex-col md:flex-row">
          <div class="flex-auto">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': purpose === 'other' }"
              @click="changeValue('purpose', 'other')"
            >
              その他
            </button>
          </div>
        </div>

        <!-- 受講の意欲 -->
        <div class="co-display-12 mb-4 font-bold">
          受講の意欲
        </div>
        <div class="mb-10 flex flex-col md:flex-row">
          <div class="mb-3 flex-auto md:mb-0">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': motivation === 1 }"
              @click="changeValue('motivation', 1)"
            >
              前向きに検討している
            </button>
          </div>
          <div class="flex-auto">
            <button
              type="button"
              class="te-button-select rounded-full py-2 hover:brightness-95"
              :class="{ 'te-is-active': motivation === 2 }"
              @click="changeValue('motivation', 2)"
            >
              話を聞いてから検討したい
            </button>
          </div>
        </div>

        <!-- 日程選択へ -->
        <ClientOnly>
          <button
            class="co-btn-submit co-btn-fixed"
            :disabled="isNextDisabled"
            @click="nextStep(1)"
          >
            日程選択へ
          </button>
        </ClientOnly>
        <span
          v-show="isError"
          class="co-display-14 mt-3 block text-co-danger-500"
        >
          未選択の項目があります
        </span>
      </div>

      <!-- ステップ2 -->
      <div
        v-if="step === 2"
        class="mt-[3.25rem] text-center"
      >
        <img
          class="mx-auto mb-5"
          src="~/assets/images/Te/TeCounseling/Apply/step-two.svg"
          alt="日程選択"
          width="218"
          height="46"
          loading="lazy"
        >
        <a
          class="co-display-13 cursor-pointer"
          @click="nextStep(-1)"
        >
          <FontAwesomeIcon
            :icon="faAngleLeft"
            class="fa-fw inline size-3"
          />前の質問に戻る
        </a>
        <div class="co-display-11 mb-8 font-bold">
          日程をご選択ください
        </div>

        <!-- ローディングアニメーション -->
        <div
          v-show="isLoading"
          class="text-co-primary-400"
        >
          <div class="min-h-[60px]">
            <div class="te-loading" />
          </div>
          <p class="text-center font-bold leading-normal">
            空いている日時を検索しております
            <br>
            今しばらくお待ちください
          </p>
        </div>

        <!-- カレンダー -->
        <TeCounselingApplyMatchingCalendar
          :appointment-form="appointmentForm"
          :appointment-form-table="appointmentFormTable"
          :range="range"
          :purpose="purpose"
          :motivation="motivation"
          :age="age"
          :gender="gender"
          :page-url="pageUrl"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  getTrialMiniCourseSchedule,
  getTrialMiniCourseScheduleTable,
} from '~/utility/fetchAPI'
import TeCounselingApplyMatchingCalendar from '~/components/Te/TeCounseling/Apply/TeCounselingApplyMatchingCalendar.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faClockNine } from '@awesome.me/kit-65d95819ce/icons/classic/regular'
import { faAngleLeft } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const props = defineProps(['pageUrl', 'isSort', 'isSortHeading', 'isEmbed'])

const isNextDisabled = ref<Boolean>(true)
const appointmentForm = ref(null)
const appointmentFormTable = ref(null)
const range = ref(2)
const purpose = ref('')
const motivation = ref(0)
const age = ref(0)
const gender = ref(0)
const isLoading = ref<Boolean>(false)
const isError = ref<Boolean>(false)
const step = ref(1)
const { $api } = useNuxtApp()

const changeValue = (category, value) => {
  switch(category) {
    case 'purpose':
      if (purpose.value !== value) {
        purpose.value = value
      }
      break
    case 'motivation':
      if (motivation.value !== value) {
        motivation.value = value
      }
      break
    case 'gender':
      if (gender.value !== value) {
        gender.value = value
      }
      break
    case 'age':
      if (age.value !== value) {
        age.value = value
      }
      break
  }

    checkNextDisabled()
  }

const nextStep = (number) => {
  if (number === 1) {
    if (!validateCategory()) {
      isError.value = true
    } else {
      isError.value = false
      step.value = 2
      getScheduleTable()
    }
  } else if (number === 2) {
    getScheduleTable()
  } else if (number < 0) {
    step.value += number
  }
}

const getScheduleTable = () => {
  isLoading.value = true
  const body: any = {
    range: range.value,
    purpose: purpose.value,
    age: age.value,
    gender: gender.value,
  }
  getTrialMiniCourseScheduleTable($api, 'htmlcss-trial', body).then(
    (response) => {
      appointmentFormTable.value = response
      isLoading.value = false
    }
  )
}

const checkNextDisabled = () => {
  if (validateCategory()) {
    isNextDisabled.value = false
  } else {
    isNextDisabled.value = true
  }
}

const validateCategory = () => {
  return (
    purpose.value === '' ||
    motivation.value === 0 ||
    age.value === 0 ||
    gender.value === 0
  ) ? false : true
}


onMounted(() => {
  getTrialMiniCourseSchedule($api, 'htmlcss-trial').then((response) => {
    appointmentForm.value = response
  })

  checkNextDisabled()
})
</script>

<style scoped>
.te-button-select {
  @apply w-[19.875rem] text-[1rem] leading-normal text-co-gray-700 bg-white border border-[#ddd] duration-500 ease-in-out;
  &.te-is-active {
    @apply text-white bg-[#62a5b6];
  }
}

.te-loading {
  position: relative;
  width: 0.625rem;
  max-height: 3rem;
  margin: 3rem auto 0;
  background: #1f7f96;
  transform: translateZ(0);
  animation: load1 1s infinite ease-in-out;
  animation-delay: -0.16s;
  &::before {
    position: absolute;
    top: 0;
    left: -0.937rem;
    width: 0.625rem;
    max-height: 3rem;
    content: '';
    background: #1f7f96;
    animation: load1 1s infinite ease-in-out;
    animation-delay: -0.32s;
  }
  &::after {
    position: absolute;
    top: 0;
    left: 0.937rem;
    width: 0.625rem;
    max-height: 3rem;
    content: '';
    background: #1f7f96;
    animation: load1 1s infinite ease-in-out;
  }
}

@keyframes load1 {
  0%,
  80%,
  100% {
    height: 1.875rem;
    box-shadow: 0 0;
  }
  40% {
    height: 2.812rem;
    box-shadow: 0 -2em;
  }
}
</style>
